import api from '@/services/api'
//import { postFindByCondition } from './holder'
const url = action => `/commondata/${action}`

export async function postFindInsuranceCompanies(){
    const { data: res } = await api.post(url('findInsuranceCompanies'))
    return res
}

export async function postFindByCondition(requestBody){
    const { data: res } = await api.post(url('findByCondition'), requestBody)
    return res
}

export async function postFindAgnecyCompanies(){
    var requestBody = {
        query_data :{
            source: 'agency_companies',
            fields: 'id,name'
        }}
    const { data: res } = await api.post(url('findByCondition'),requestBody)
    return res
}

export async function postFindHolders(){
    const { data: res } = await api.post(url('findHolders'))
    return res
}

export async function postFindSalesmans(requestBody){

    const { data: res } = await api.post(url('findByCondition'),requestBody)
    return res
}